<!-- Header -->
<div
  class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mx-3 -mt-3"
>
  <h2 class="mb-0 text-sm" aria-label="folder-dialog-header">
    {{
      activeFolder
        ? ('ADMIN.DOCUMENT.UPDATE_FOLDER' | translate)
        : ('ADMIN.DOCUMENT.ADD_NEW_FOLDER' | translate)
    }}
  </h2>
  <div
    class="fa fa-times text-xl text-600 cursor-pointer"
    (click)="close()"
    aria-label="close-folder-dialog"
  ></div>
</div>
<!-- Header -->
@if (folderForm) {
  <form
    #form="ngForm"
    [formGroup]="folderForm"
    (ngSubmit)="saveFolderForm()"
    aria-label="folder-form"
  >
    <!-- Content -->
    <div class="surface-100 p-3 text-sm -mx-3 w-22rem md:w-30rem">
      <div class="mb-3">
        <label
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="folder-name-primary-label"
        >
          {{ 'ADMIN.DOCUMENT.FOLDER_NAME' | translate }}
          @if (secondaryLanguage) {
            <span>({{ primaryLanguage | translate }})</span>
          }
        </label>
        <input
          formControlName="name_primary_language"
          type="text"
          class="w-full text-sm"
          pInputText
          placeholder="Name"
          aria-label="folder-name-primary-input"
        />
        @if (Primary?.touched && NamePrimary?.invalid) {
          <app-error-msg
            [errors]="Primary?.errors"
            [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_NAME' | translate"
          />
        }
      </div>
      <div class="mb-3">
        <label
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="folder-description-primary-label"
        >
          {{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }}
          @if (secondaryLanguage) {
            <span>({{ primaryLanguage | translate }})</span>
          }
        </label>
        <textarea
          formControlName="description_primary_language"
          pInputTextarea
          class="w-full h-4rem"
          placeholder="{{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }}"
          aria-label="folder-description-primary-input"
        ></textarea>
        @if (Primary?.touched && NamePrimary?.invalid) {
          <app-error-msg
            [errors]="Primary?.errors"
            [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_NAME' | translate"
          />
        }
      </div>
      @if (isSecondaryLanguage | async) {
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="folder-name-secondary-label"
          >
            {{ 'ADMIN.DOCUMENT.FOLDER_NAME' | translate }}
            @if (isSecondaryLanguage | async) {
              <span>({{ SecondaryLanguage }})</span>
            }
          </label>
          <input
            formControlName="name_secondary_language"
            type="text"
            class="w-full text-sm"
            pInputText
            placeholder="Name"
            aria-label="folder-name-secondary-input"
          />
          @if (Secondary?.touched && Secondary?.invalid) {
            <app-error-msg
              [errors]="Secondary?.errors"
              [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_DESC' | translate"
            />
          }
        </div>
      }
      @if (isSecondaryLanguage | async) {
        <div class="">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="folder-description-secondary-label"
          >
            {{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }}
            @if (isSecondaryLanguage | async) {
              <span>({{ SecondaryLanguage }})</span>
            }
          </label>
          <textarea
            formControlName="description_secondary_language"
            pInputTextarea
            class="w-full h-4rem"
            placeholder="{{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }}"
            aria-label="folder-description-secondary-input"
          ></textarea>
          @if (SecondaryDesc?.touched && SecondaryDesc?.invalid) {
            <app-error-msg
              [errors]="SecondaryDesc?.errors"
              [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_DESC' | translate"
            />
          }
        </div>
      }
    </div>
    <!-- Content -->

    @if (showAuditLogsFeature && activeFolder?.id) {
      <div class="px-3 pb-3 border-top-1 border-300 -mx-3">
        <fitness-force-audit-trail-mini entityType="form_folders"
          [entityId]="activeFolder.id"
          [tenantId]="tenantId"
          [tenantData]="[]"
          [maxEvents]="10"
          [showStats]="true"
          [showFilters]="true"
          [showPagination]="true"
          [showCloseButton]="false"
          height="40vh"
          title="Attachment Folder Activity Log"
          data-testid="audit-trail-mini-component" />
      </div>
    }

    <!-- Footer -->
    <div
      class="p-3 flex justify-content-between align-items-center border-top-1 border-300 -mx-3 -mb-3"
    >
      <button
        pButton
        pRipple
        type="button"
        label="{{ 'ADMIN.COMMON.CANCEL' | translate }}"
        class="p-button-text text-sm"
        (click)="close()"
        aria-label="cancel-folder-dialog-button"
        data-testid="cancel-folder-dialog-button"
      ></button>
      <button
        [loading]="isSubmitting"
        pButton
        pRipple
        type="submit"
        label="{{
          activeFolder
            ? ('ADMIN.DOCUMENT.UPDATE_FOLDER' | translate)
            : ('ADMIN.DOCUMENT.ADD_NEW_FOLDER' | translate)
        }}"
        class="text-sm"
        aria-label="submit-folder-dialog-button"
        data-testid="submit-folder-dialog-button"
      ></button>
    </div>
    <!-- Footer -->
  </form>
}
